import {
  IPayloadPayeeMatchParameters,
  ResponseDataPayeeMatch,
  ResponsePayeeMatchParametersList,
} from './../models/payeeMatchParameters.model'

import axiosInstance from '../utils/api-util/utilApi'
import { IGetExportData } from '../components/common/new-table/table-setting.model'

const config = { baseURL: process.env.REACT_APP_CLIENT_SETUP_SERVICE_URL || '' }

export const addNewPayeeMatchParameters = (data: IPayloadPayeeMatchParameters): Promise<ResponseDataPayeeMatch> => {
  return axiosInstance.post(`/api/payeeMatchParameters/add`, data, config)
}

export const getListPayeeMatchParameters = (
  payload: Partial<IGetExportData>,
): Promise<ResponsePayeeMatchParametersList> => {
  return axiosInstance.post(`/api/payeeMatchParameters/filter`, JSON.stringify(payload), config)
}

export const deletePayee = (id: string) => {
  return axiosInstance.delete(`/api/payeeMatchParameters/${id}`, config)
}

export const getPayeeMatchParametersDetail = (id: any): Promise<any> => {
  return axiosInstance.get(`/api/payeeMatchParameters/${id}`, config)
}

export const editPayee = (data: IPayloadPayeeMatchParameters, id: any): Promise<ResponseDataPayeeMatch> => {
  return axiosInstance.put(`/api/payeeMatchParameters/${id}`, data, config)
}
